import script from "./customer-price-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./customer-price-editor.vue?vue&type=script&setup=true&lang=ts"

import "./customer-price-editor.vue?vue&type=style&index=0&id=512c02dc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-512c02dc"]])

export default __exports__